﻿//==========================================================================================================
// Copyright (C) Nore Technology AB. All Rights Reserved.
//==========================================================================================================

import type {
    IndividualIdentifierTypes,
    OrganizationIdentifierSubTypes,
    OrganizationIdentifierTypes,
} from "~base/Internationalization/ConfigurationInfo";
import type { IdentifierParseTypes } from "~base/Types/Identifier";
import * as sessionModel from "~base/Services/API/Session/Model";
import { getSubjectIdentifierConType } from "~base/Types/IdentifierConverter";
import type { IntlContext } from "~base/Internationalization/IntlContext";

//-------------------------------------------------------------------------------------
// Imports
//-------------------------------------------------------------------------------------

//-------------------------------------------------------------------------------------
// State
//-------------------------------------------------------------------------------------

type SetLoading = { type: "setLoading" };
type SetFetchError = { type: "fetchError"; message: string };
type Navigate = { type: "navigate"; uri: string; replace?: boolean };

export type SessionInvitePageViewAction = SetLoading | SetFetchError | Navigate;

export interface SessionInvitePageState {
    errorMessage?: string;
    loading: boolean;
    navigateUri?: string;
    navigateReplace?: boolean;
}

export function reducer<T>(
    state: SessionInvitePageState,
    action: SessionInvitePageViewAction
): SessionInvitePageState {
    switch (action.type) {
        case "setLoading": {
            return {
                ...state,
                errorMessage: null,
                loading: true,
            };
        }
        case "fetchError": {
            return {
                ...state,
                errorMessage: action.message,
            };
        }
        case "navigate": {
            return {
                ...state,
                errorMessage: null,
                loading: action.uri ? true : false,
                navigateUri: action.uri,
                navigateReplace: action.replace,
            };
        }
    }
}
